import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle` 
  :root{
    --white : #fff; 
    --black : #000;
    --indigo-1 : #3949ab;
    --indigo-2 : #283593;
    --indigo-3 : #1a237e;  
    --blue-1 : #1e88e5;
    --blue-2 : #1565c0;
    --blue-3 : #0d47a1;
    --light-blue-1 : #039be5;
    --light-blue-2 : #0277bd;
    --light-blue-3 : #01579b;
    --cyan-1 : #00acc1;
    --cyan-2 : #00838f;
    --cyan-3 : #006064;
    --green-1 : #43a047;
    --green-2 : #2e7d32;
    --green-3: #1b5e20;
    --red-1: #e53935 ;   
    --red-2: #c62828 ;   
    --red-3: #b71c1c ;   
    --light-gray-1: #f5f5f5 ;
    --light-gray-2: #e0e0e0 ;
    --light-gray-3: #9e9e9e  ;
    --gray-1 : #616161;
    --gray-2 : #424242;
    --gray-3 : #212121;
    --amber-1 : #ffb300;
    --amber-2 : #ffa000;
    --mainTransition : all 0.4s;
    --fontFamily-sans: Montserrat,system-ui,-apple-system,BlinkMacSystemFont, "Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif, "Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";
    --fontFamily-serif: "Merriweather","Georgia",Cambria,"Times New Roman", Times,serif;
  }
  *, *:after, *:before{
    padding : 0; 
    margin: 0;
    box-sizing: border-box;
  } 
  html{    
    overflow-x :hidden;
  }
  body{    
    background-color : ${({ theme }) =>
      theme ? theme.background : 'var(--white)'}    ;
    color : ${({ theme }) => (theme ? theme.text : 'var(--gray-3)')} ;
    margin : 0; 
    padding : 0 ;    
    overflow-x: hidden;           
    font-family : var(  --fontFamily-sans);
    transition: background-color 0.1s ease;
    font-size : 1rem;   
  }
`;
